/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Swedish
export default {
  'feedback-collector.anonymous': 'Denna feedback skickas anonymt. Atlassian kommer inte att kunna kontakta dig direkt angående denna feedback',
  'feedback-collector.anonymous.title': 'Anonym feedback',
  'feedback-collector.can-be-contacted.label': 'Ja, Atlassian-team får kontakta mig för att lära sig om mina erfarenheter i syfte att förbättra Atlassians produkter och tjänster. Jag bekräftar <a>Atlassians sekretesspolicy</a>',
  'feedback-collector.cancel-button.label': 'Avbryt',
  'feedback-collector.default.custom.textarea.label': 'Undrade du något?',
  'feedback-collector.enrol-in-research.label': 'Jag vill delta i produktundersökningar',
  'feedback-collector.feedback-title': 'Dela dina åsikter',
  'feedback-collector.form.bug.label': 'Beskriv buggen eller problemet',
  'feedback-collector.form.comment.label': 'Berätta vad du tycker',
  'feedback-collector.form.empty.label': 'Välj ett alternativ',
  'feedback-collector.form.question.label': 'Vad vill du veta?',
  'feedback-collector.form.suggestion.label': 'Berätta för oss vad du vill ska förbättras',
  'feedback-collector.option.bug.label': 'Rapportera en bugg',
  'feedback-collector.option.comment.label': 'Lämna en kommentar',
  'feedback-collector.option.default.label': 'Välj feedback',
  'feedback-collector.option.default.placeholder': 'Välj en',
  'feedback-collector.option.question.label': 'Ställ en fråga',
  'feedback-collector.option.suggestion.label': 'Föreslå en förbättring',
  'feedback-collector.required.fields.summary': 'Obligatoriska fält är markerade med en asterisk',
  'feedback-collector.submit-button.label': 'Skicka feedback',
  'feedback-collector.success-flag.description': 'Din värdefulla feedback hjälper oss att ständigt förbättra våra produkter.',
  'feedback-collector.success-flag.title': 'Tack!',
  'feedback-collector.summary-placeholder': 'Berätta vad du tycker',
  'proforma-form-builder.feedback-icon-label': 'Feedback',
  'proforma-form-builder.give-feedback': 'Ge feedback'
};